import * as React from 'react';
import { observer, inject } from "mobx-react";
import MomentUtils from '@date-io/moment';
import 'moment/locale/sr';
import { Button, FormControlLabel, Checkbox, FormControl, RadioGroup, Radio } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from '@material-ui/icons/Cancel';

// =====================================
// CONSTS
import { OrderLabels } from '../../const/OrderLabels';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { ProductNotes } from '../../const/ProductNotes';

@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class NewOrderDetails extends React.Component<{ ordersStore?: IOrdersStore; customerId?: any; orderId?: any; }, {}> {

    renderIconNote = (note) => {
        let iconNoteComponent: any = null;

        if(note === ProductNotes.added) {
            iconNoteComponent = <AddCircleIcon className="note-icon add-note"/>;
        } else if (note === ProductNotes.modified)  {
            iconNoteComponent = <EditIcon className="note-icon edit-note"/>;
        } else if (note === ProductNotes.canceled)  {
            iconNoteComponent = <CancelIcon className="note-icon cancel-note"/>;
        } else {
            iconNoteComponent = null;
        }

        return iconNoteComponent
    }

    render() {
        const productsForOrder = this.props.ordersStore.productsForOrder.filter(product => product.productOrderedAmount !== 0 || product.note.length > 0);

        return (
            <div className="new-order">
                <Header
                    title={'Pregled porudžbine'}
                    isBackButtonVisible={true}
                    samePageAction={this.props.ordersStore.goBackToOrder} />

                <div className="container">
                    <div className="new-order-header">
                        <div className="bold-text">Datum isporuke: {this.props.ordersStore.orderRequestedDeliveryLabel}</div>
                        <div className="order-pick-container">
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <KeyboardDatePicker
                                    autoOk
                                    disableToolbar
                                    variant="inline"
                                    format="DD.MM.YYYY"
                                    margin="normal"
                                    className="form-date-picker"
                                    label="Izaberi datum"
                                    disablePast={!this.props.ordersStore.isEditOrder}
                                    value={this.props.ordersStore.orderRequestedDeliveryDate}
                                    onChange={this.props.ordersStore.handleChangeOrderRequestedDeliveryDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.props.ordersStore.orderDeliverAsSoonAsPossible}
                                        onChange={this.props.ordersStore.handleChangeOrderDeliverAsSoonAsPossible}
                                        name="checkedB"
                                        color="primary" />
                                }
                                label="Što pre"
                                className="form-checkbox"
                            />
                        </div>
                    </div>

                    <div className="new-order-header">
                        <FormControl component="fieldset">
                            <div className="bold-text">Oznaka</div>
                            <RadioGroup row aria-label="orderLabel"
                                value={this.props.ordersStore.orderLabel}
                                onChange={this.props.ordersStore.handleChangeOrderLabel}>
                                <FormControlLabel value={OrderLabels.V} control={<Radio />} label={OrderLabels.V} />
                                <FormControlLabel value={OrderLabels.R} control={<Radio />} label={OrderLabels.R} />
                            </RadioGroup>
                        </FormControl>
                    </div>

                    {this.props.ordersStore.locationCode !== "0" ?
                        <div className="new-order-header">
                            <div className="bold-text">Lokacija</div>
                            <div>{this.props.ordersStore.locationAddress}</div>
                        </div> : null}

                    {productsForOrder.map((product, i) => {
                        return <div className="order-container" key={i}>
                            <div className="product">
                                <div className="product-center-row">
                                    <div className={`${product.note === ProductNotes.replaced ? "product-name product-name-strike" : "product-name"}`}>{product.name}</div>
                                    <div>
                                        {this.renderIconNote(product.note)}
                                    </div>
                                </div>
                                <div className="product-row"> Cena:
                                    {product.customSalesPrice !== "" ?
                                        (+product.customSalesPrice).toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                        : product.acquisitionPrice.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD
                                </div>
                                <div className="product-row">
                                    <div>Šifra: {product.code}</div>
                                    <div>{product.productOrderedAmount}</div>
                                </div>
                            </div>
                        </div>
                    })}

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="edit-btn"
                        onClick={this.props.ordersStore.goToArticlesPriceChange}
                        startIcon={<EditIcon />}
                    >Promeni cenu artikala
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="save-btn"
                        disabled={this.props.ordersStore.isSaveOrderBtnDisabled}
                        onClick={() => { this.props.ordersStore.saveOrder(this.props.customerId, this.props.orderId) }}
                        startIcon={<SaveIcon />}
                    >Poruči
                    </Button>
                </div>
            </div>
        );
    }
}